import PropTypes from 'prop-types';
import React from 'react';
import { t } from 'services/translation';

const PLACES_LEFT_THRESHOLD = 8;

const Hint = ({ isSoldOut, spots }) => {
  const hintText = `${spots} ${t(spots > 1 ? 'spots' : 'spot')}`;
  let view = null;

  if (isSoldOut) {
    if (spots === 0) {
      view = <span className="hint sold-out">{t('SOLD_OUT')}</span>;
    } else {
      view = <span className="hint sold-out">{hintText}</span>;
    }
  } else if (spots <= PLACES_LEFT_THRESHOLD) {
    view = <span>{hintText}</span>;
  }
  return view;
};

Hint.displayName = 'BookingRequest-Times-Hint';

Hint.propTypes = {
  spots: PropTypes.number.isRequired,
  isSoldOut: PropTypes.bool,
};

Hint.defaultProps = {
  isSoldOut: false,
};

export default Hint;
